module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp123_6000.d871fd2c.png";